import * as types from '../mutation-types'
import ordersRepository from '../../api/ordersRepository'

const state = {
    orderToCreate: {},
    orderItemToCreate: {},
    isOrderCreated: false,
    isOrderItemDeleted: false,
    isOrderItemCreated: false,
    orderItemsAreCopied: false,
    order: {},
    orderItems: [],
    orderItemsFiltered: [],
    quoteToCreate: {},
    categories: []
}

const getters = {
    orderToCreate: state => state.orderToCreate,
    orderItemToCreate: state => state.orderItemToCreate,
    isOrderCreated: state => state.isOrderCreated,
    isOrderItemCreated: state => state.isOrderItemCreated,
    orderItemsAreCopied: state => state.orderItemsAreCopied,
    order: state => state.order,
    orderItems: state => state.orderItems,
    categories: state => state.categories,
    orderItemsFiltered: state => state.orderItemsFiltered,
}

const actions = {
    createOrder({ commit }) {
        return ordersRepository.createOrder(state.orderToCreate).then((response) => {
            if (response.data.success) {
                commit(types.SET_ORDER_IS_CREATED, true)
                commit(types.SET_ORDER, response.data.message)
            } else {
                commit(types.SET_ORDER_IS_CREATED, false)
            }
        })
    },
    createOrderForTemporaryCustomer({ commit }) {
        return ordersRepository.createOrderForTemporaryCustomer(state.orderToCreate).then((response) => {
            if (response.data.success) {
                commit(types.SET_ORDER_IS_CREATED, true)
                commit(types.SET_ORDER, response.data.message)
            } else {
                commit(types.SET_ORDER_IS_CREATED, false)
            }
        })
    },
    createOrderItem({ commit }) {
        return ordersRepository.createOrderItem(state.orderItemToCreate).then((response) => {
            if (response.data.success) {
                commit(types.SET_ORDER_ITEM_IS_CREATED, true)
                if (response.data.message) {
                    commit(types.ADD_ORDER_ITEM_TO_ORDER_ITEMS, response.data.message)
                }
            } else {
                commit(types.SET_ORDER_ITEM_IS_CREATED, false)
            }
        })
    },
    deleteOrderItem({ commit }, orderItemProductId) {
        return ordersRepository.deleteOrderItem(orderItemProductId).then((response) => {
            if (response.data.success) {
                commit(types.SET_ORDER_ITEM_IS_DELETED, true)
            } else {
                commit(types.SET_ORDER_ITEM_IS_DELETED, false)
            }
        })
    },
    getOrderItemsByCategoryForCustomer({ commit }, category) {
        return ordersRepository.getOrderItemsByCategoryForCustomer(category).then((response) => {
            commit(types.SET_ORDER_ITEMS, response.data)
        })
    },
    getOrderItemsForCustomer({ commit }) {
        return ordersRepository.getOrderItemsForCustomer().then((response) => {
            commit(types.SET_ORDER_ITEMS, response.data)
        })
    },
    copyOrderItemsFromCustomer({ commit }, fromDebtorNumberToId) {
        return ordersRepository.copyOrderItemsFromCustomer(fromDebtorNumberToId).then((response) => {
            if (response.data.success) {
                commit(types.SET_ORDER_ITEMS_COPIED, true)
            } else {
                commit(types.SET_ORDER_ITEMS_COPIED, false)
            }
        })
    }
}

const mutations = {
    [types.SET_ORDER_TO_CREATE](state, payload) {
        state.orderToCreate = payload
    },
    [types.SET_ORDER_ITEM_TO_CREATE](state, payload) {
        state.orderItemToCreate = payload
    },
    [types.SET_ORDER_IS_CREATED](state, payload) {
        state.isOrderCreated = payload
    },
    [types.SET_ORDER_ITEM_IS_CREATED](state, payload) {
        state.isOrderItemCreated = payload
    },
    [types.SET_ORDER_ITEM_IS_DELETED](state, payload) {
        state.isOrderItemDeleted = payload
    },
    [types.SET_ORDER](state, payload) {
        state.order = payload
    },
    [types.SET_ORDER_ITEMS](state, payload) {
        state.orderItems = payload
    },
    [types.SET_ORDER_ITEMS_COPIED](state, payload) {
        state.orderItemsAreCopied = payload
    },
    [types.SET_ORDER_ITEMS_FILTERED](state, payload) {
        state.orderItemsFiltered = payload
    },
    [types.ADD_ORDER_ITEM_TO_ORDER_ITEMS](state, payload) {
        state.orderItems.push(payload)
    },
    [types.REMOVE_ORDERITEM_FROM_ORDERITEMS_FILTERED](state, payload) {
        state.orderItemsFiltered.forEach((orderItem, index) => {
            if (orderItem.productId === payload) {
                state.orderItemsFiltered.splice(index, 1)
            }
        })
    },
    [types.SET_QUOTE_TO_CREATE](state, payload) {
        state.quoteToCreate = payload
    },
    [types.SET_CATEGORIES](state, payload) {
        state.categories = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
